import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Abstracts} from '../model/Abstracts';
import {AbstractsService} from '../service/abstracts.service';
declare var MathJax:any;

@Component({
  selector: 'app-abstracts',
  templateUrl: './abstracts.component.html',
  styleUrls: ['./abstracts.component.css']
})
export class AbstractsComponent implements OnInit, AfterViewInit {

  abstracts: Abstracts[]

  constructor(private abstractsService : AbstractsService) { }

  ngOnInit() {
    this.abstracts = this.abstractsService.getAbstracts();
  }

  ngAfterViewInit(){
    MathJax.Hub.Queue(["Typeset",MathJax.Hub,"abstracts"]);
  }


}



// WEBPACK FOOTER //
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/abstracts/abstracts.component.ts